"use strict";

var pendingMixedOriginRetry = null;
var lastFocusTrigger = null;
var FOCUS_AFTER_EMPTY_KEY = "storeSelector.focusAfterEmptyCart";
var STABLE_FOCUS_TARGETS = [".cart-empty-text", ".cart-empty h1", "#maincontent", "main", "h1"];
var MODAL_FOCUSABLE = "a[href], button, input, select, textarea, [tabindex]";

/**
 * Lleva el foco al primer destino estable y visible (mensaje de carrito vacío,
 * si no #maincontent, etc.). Les agrega tabindex="-1" si no son focuseables.
 * @returns {void}
 */
function focusStableTarget() {
    for (var i = 0; i < STABLE_FOCUS_TARGETS.length; i++) {
        var $el = $(STABLE_FOCUS_TARGETS[i]).filter(":visible").first();

        if ($el.length) {
            if (!$el.is("a[href], button, input, select, textarea, [tabindex]")) {
                $el.attr("tabindex", "-1");
            }
            $el[0].focus({ preventScroll: true });
            return;
        }
    }
}

/**
 * Flujos SIN recarga (PLP): enfoca el destino estable cuando el modal termina de cerrarse, para que Bootstrap no lo pise.
 * @returns {void}
 */
function focusAfterEmptyCart() {
    var $modal = $("#storeSelectorModal");

    lastFocusTrigger = null; // el disparador ya no es un destino válido

    if ($modal.hasClass("show")) {
        $modal.one("hidden.bs.modal", focusStableTarget);
    } else {
        focusStableTarget();
    }
}

/**
 * Flujos CON recarga: deja una marca que se consume al cargar la página nueva.
 * Llamar justo antes de location.reload().
 * @returns {void}
 */
function prepareFocusAfterReload() {
    lastFocusTrigger = null;
    try {
        sessionStorage.setItem(FOCUS_AFTER_EMPTY_KEY, "1");
    } catch (e) {
        // sessionStorage no disponible: el foco queda en el comportamiento por defecto.
    }
}

/**
 * Muestra el modal de feedback (mixed-origin, método incompleto, sin stock)
 * @param {string} message - copy del backend
 * @param {string} title - título del backend
 * @param {boolean} showFooter - si deben mostrarse las acciones (Vaciar carrito / Finalizar compra)
 * @param {Object} [retry] - {url, data} de la petición a reintentar después
 *   de vaciar el carrito.
 */
function showMixedOriginModal(message, title, showFooter, retry, titleBtn) {
    var $modal = $("#storeSelectorModal");
    var $title = $modal.find("#storeSelectorModalTitle");
    var $footer = $modal.find("[data-js-store-modal-footer]");
    var $btnFooter =  $modal.find("[data-js-method-btn-msg]");

    $title.text(title || $title.data("default-title"));

    if (message) {
        $modal.find(".store-selector-modal__message").text(message);
    }

    if (titleBtn) {
         $modal.find($btnFooter).text(titleBtn);
    }

    $footer.toggleClass("d-none", !showFooter);

    pendingMixedOriginRetry = retry || null;

    if (!$modal.hasClass("show")) {
        var active = document.activeElement;
        lastFocusTrigger = active && active !== document.body && !$modal[0].contains(active)
            ? active : null;
    }

    $modal.appendTo("body").modal("show");
}

/**
 * Cablea las acciones del modal de mixed-origin (vaciar carrito)
 */
function bindMixedOriginModal() {
    $("body").on("click", ".js-store-empty-cart", function () {
        var $btn = $(this);
        var emptyUrl = $btn.attr("data-url");
        var retry = pendingMixedOriginRetry;

        $btn.prop("disabled", true);

        $.ajax({
            url: emptyUrl,
            type: "POST",
            dataType: "json",
            success: function () {
                var canonicalEvents = require("../../analytics/canonicalEvents");
                var previousStoreId =
                    $('[name="selectedStoreId"]').val() || null;

                canonicalEvents.pushCanonicalEvent("store_cleared", {
                    surface: "pdp",
                    source: "change_store_confirmation",
                    selected_store: null,
                    delivery_method: null,
                    previous_selected_store: previousStoreId
                        ? canonicalEvents.toStorePayload({
                              ID: previousStoreId,
                              name:
                                  $('[name="selectedStoreName"]').val() || null,
                              city:
                                  $('[name="selectedStoreCity"]').val() || null,
                          })
                        : null,
                    cart_had_items: true,
                });

                canonicalEvents.updateGlobalDeliveryState(null, null);

                if (retry) {
                    $.ajax({
                        url: retry.url,
                        type: "POST",
                        dataType: "json",
                        data: retry.data,
                        success: function () {
                            pendingMixedOriginRetry = null;
                            $("#storeSelectorModal").modal("hide");
                            prepareFocusAfterReload();
                            location.reload();
                        },
                        error: function () {
                            pendingMixedOriginRetry = null;
                            $btn.prop("disabled", false);
                            $("#storeSelectorModal").modal("hide");
                            $("body").trigger("delivery-selector:error");
                        },
                    });

                    return;
                }

                $("#storeSelectorModal").modal("hide");
                prepareFocusAfterReload();
                location.reload();
            },
            error: function () {
                $btn.prop("disabled", false);
            },
        });
    });
}

// Al cerrar el modal, el foco vuelve al elemento que lo abrió.
$(document).on("hidden.bs.modal", "#storeSelectorModal", function () {
    var el = lastFocusTrigger;
    lastFocusTrigger = null;
    if (el && document.body.contains(el) && !el.disabled && $(el).is(":visible")) {
        el.focus();
    }
});

$(document).on("keydown", "#storeSelectorModal a.checkout-btn", function (e) {
    if (e.key === " " || e.key === "Spacebar" || e.keyCode === 32) {
        e.preventDefault();
        if (!$(this).hasClass("disabled")) {
            this.click();
        }
    }
});

/**
 * Elementos tabulables y visibles dentro del modal, en orden de DOM.
 * @param {jQuery} $modal
 * @returns {jQuery}
 */
function getModalFocusables($modal) {
    return $modal.find(MODAL_FOCUSABLE).filter(function () {
        return this.getAttribute("tabindex") !== "-1" && !this.disabled && $(this).is(":visible");
    });
}

$(document).on("keydown", "#storeSelectorModal", function (e) {
    if (e.key !== "Tab" && e.keyCode !== 9) {
        return;
    }

    var modal = this;
    var $focusables = getModalFocusables($(modal));
    var active = document.activeElement;

    if (!$focusables.length) {
        e.preventDefault();
        modal.focus();
        return;
    }

    var first = $focusables[0];
    var last = $focusables[$focusables.length - 1];
    var outside = !modal.contains(active) || active === modal;

    if (e.shiftKey) {
        if (outside || active === first) {
            e.preventDefault();
            last.focus();
        }
    } else if (outside || active === last) {
        e.preventDefault();
        first.focus();
    }
});

$(document).on("shown.bs.modal", "#storeSelectorModal", function () {
    var modal = this;
    var $focusables = getModalFocusables($(modal));
    var $preferred = $focusables.filter(".checkout-btn").not(".disabled").first();
    var target = $preferred.length ? $preferred[0] : $focusables[0];

    if (!target) {
        if (!modal.hasAttribute("tabindex")) {
            modal.setAttribute("tabindex", "-1");
        }
        target = modal;
    }

    target.focus();
});

// Página recargada tras vaciar el carrito → foco en el destino estable.
$(function () {
    try {
        if (sessionStorage.getItem(FOCUS_AFTER_EMPTY_KEY) === "1") {
            sessionStorage.removeItem(FOCUS_AFTER_EMPTY_KEY);
            focusStableTarget();
        }
    } catch (e) {
    }
});

module.exports = {
    showMixedOriginModal: showMixedOriginModal,
    bindMixedOriginModal: bindMixedOriginModal,
    focusAfterEmptyCart: focusAfterEmptyCart,
    prepareFocusAfterReload: prepareFocusAfterReload,
};